export default class IngredientTranslation {
    id: number;
    name: string;
    locale: string;
    motive_id: number;
}
